// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"35cec784","453":"06ada9e3","948":"f413a8c5"}[chunkId] + ".chunk.js";
};